import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SHOP_SECTION_ID, scrollToSection } from '../utils/scroll';
import { goToShop } from '../utils/shopIntent';
import { pricingConfig } from '../data/pricing';
import type { BundleId } from '../data/pricing';
import { HomeHero } from '../components/home/HomeHero';
import { QuickPick } from '../components/home/QuickPick';
import { ProductReveal } from '../components/home/ProductReveal';
import { MountTeaser } from '../components/home/MountTeaser';
import { PromiseSection } from '../components/home/PromiseSection';
import { ApplicationsStrip } from '../components/home/ApplicationsStrip';
import { ClosingCta } from '../components/home/ClosingCta';
import { ShopTabs } from '../components/shop/ShopTabs';
import { TestimonialsMarquee } from '../components/home/TestimonialsMarquee';
import { AlwaysReady } from '../components/home/AlwaysReady';
import { FeaturedSystems } from '../components/shop/FeaturedSystems';
import { PositionsCalculator } from '../components/shop/PositionsCalculator';
import { GuaranteeStrip } from '../components/shop/GuaranteeStrip';
import { HomeFaq } from '../components/home/HomeFaq';
import { ProductVideo } from '../components/home/ProductVideo';
export function Home() {
  const {
    hash,
    search
  } = useLocation();

  // Arriving via /#shop-systems (SHOP NOW from another page), optionally with ?system=sys8.
  useEffect(() => {
    const target = hash.replace('#', '');
    if (target !== SHOP_SECTION_ID && target !== 'reviews') return;
    const system = new URLSearchParams(search).get('system');
    const intent = system && pricingConfig.bundles.some(b => b.id === system) ? system as BundleId : null;
    const id = window.setTimeout(() => intent ? goToShop(intent) : scrollToSection(target), 80);
    return () => window.clearTimeout(id);
  }, [hash, search]);
  return <>
      <HomeHero data-id="element-1102" data-mp="1u82yot86legp" />
      <QuickPick data-id="element-1103" data-mp="1u9e5l1wxb2c1" />
      <ProductVideo data-id="element-1104" data-mp="1u8uspzm4r44v" />
      <ProductReveal data-id="element-1105" data-mp="1uap68sv2ntyx" />
      <MountTeaser data-id="element-1106" data-mp="1kkyzp68qzhp5" />
      <AlwaysReady data-id="element-1107" data-mp="1kkh4mcxtn9it" />
      <FeaturedSystems data-id="element-1108" data-mp="1kj5rvnmeerfk" />

      <section id={SHOP_SECTION_ID} tabIndex={-1} aria-labelledby="paths-title" className="scroll-mt-[72px] border-t mf-hairline bg-deep focus:outline-none" data-id="element-1109" data-mp="1kmto4uj89rxz">
        <div className="mx-auto max-w-site px-5 py-10 md:px-8 md:py-14" data-id="element-1110" data-mp="1aonokjkw8xwa">
          <h2 id="paths-title" className="max-w-4xl font-display text-5xl font-semibold uppercase leading-[0.92] md:text-7xl" data-id="element-1111" data-mp="1fm5xi9ywvd4a">
            Choose your <span className="text-ice" data-id="element-1112" data-mp="28abimxtvn44n">MarineForceLED System</span>
          </h2>
          <p className="mt-5 font-display text-lg font-semibold uppercase tracking-[0.08em] text-white md:text-xl" data-id="element-1113" data-mp="28ce5j8zqgh55">
            From your first lighting position to a complete backup lighting system.
          </p>
          <p className="mt-4 font-display text-base font-semibold uppercase tracking-[0.14em] text-ice" data-id="element-1114" data-mp="1yi5k1594dogh">Install once. Swap whenever you need.</p>
          <div className="mt-6 md:mt-8" data-id="element-1115" data-mp="2r1ujay0fi63i">
            <ShopTabs data-id="element-1116" data-mp="2r2vtz1dj8qkp" />
          </div>
          <GuaranteeStrip data-id="element-1117" data-mp="flamnu6hpu7h" />
        </div>
      </section>

      <section id="find-system" tabIndex={-1} aria-labelledby="positions-title" className="scroll-mt-[72px] border-t mf-hairline bg-[#091C31] focus:outline-none" data-id="element-1118" data-mp="fjpntsd57p3t">
        <div className="mx-auto max-w-site px-5 py-10 md:px-8 md:py-14" data-id="element-1119" data-mp="ofyo198y2rr0">
          <h2 id="positions-title" className="max-w-3xl font-display text-5xl font-semibold uppercase leading-[0.92] md:text-6xl" data-id="element-1120" data-mp="kd2b9z635puz">
            How many lighting positions <span className="text-ice" data-id="element-1121" data-mp="3ntskemwysj0w">do you want?</span>
          </h2>
          <p className="mt-5 max-w-xl text-lg text-titanium" data-id="element-1122" data-mp="3nvlru4fej79y">
            Pick your positions and we’ll match the official system — with an optional charged backup set.
          </p>
          <div className="mt-6 md:mt-8" data-id="element-1123" data-mp="qnv2dxu61nf">
            <PositionsCalculator data-id="element-1124" data-mp="1h29x78ama0zf" />
          </div>
        </div>
      </section>

      <TestimonialsMarquee data-id="element-1125" data-mp="1c3qb97w0wp72" />
      <PromiseSection data-id="element-1126" data-mp="1c4hvjmk670i1" />
      <ApplicationsStrip data-id="element-1127" data-mp="1c36tbr6di0t1" />
      <HomeFaq data-id="element-1128" data-mp="1c5t37xgqksef" />
      <ClosingCta data-id="element-1129" data-mp="27dwn4v75fp11" />
    </>;
}